const PreLoader = () => {
    return (
        <div className="preloader">
            <div className="preloader__spiner">
                <div className="preloader__circles">
                    <div className="preloader__circle-1" />
                    <div className="preloader__circle-2" />
                </div>
            </div>
        </div>
    );
};

export default PreLoader;
